import Vue from 'vue'
import Router from 'vue-router'
 
// 桌面端页面组件
import MyMessage from '@/pages/MyMessage'
import OwnWrite from '@/pages/OwnWrite'
import WeiShenPi from '@/pages/WeiShenPi'
import QiyeBang from '@/pages/QiyeBang'
import GeRen from '@/pages/GeRen'
import ShuJu from '@/pages/ShuJu'
import ShuJuOld from '@/pages/ShuJuOld'
import HelloWorld from '@/components/HelloWorld.vue'
import TongXunLu from '@/pages/TongXunLu.vue'

// 移动端页面组件
import MobileHelloWorld from '@/pages/moblie/MobileHelloWorld.vue'
import IndexInfo from '@/pages/moblie/IndexInfo.vue'
import VisitorForm from '@/pages/moblie/VisitorForm.vue'
import DaofangShenpi from '@/pages/moblie/DaofangShenpi.vue'
import DaofangShenpi2 from '@/pages/moblie/DaofangShenpi2.vue'
import YuyueRecord from '@/pages/moblie/YuyueRecord.vue'

Vue.use(Router)
 
// 桌面端路由规则
const pcRoutes = [
  {
    path: '/',
    component: HelloWorld,
    children: [
      {
        path: "/MyMessage",
        name: "MyMessage",
        component: MyMessage,
        meta: { title: "访客帮填登记表" }
      },
      {
        path: "/OwnWrite",
        name: "OwnWrite",
        component: OwnWrite,
        meta: { title: "访客自行填写" }
      },
      {
        path: "/shenpi",
        name: "WeiShenPi",
        component: WeiShenPi,
        meta: { title: "审批页" }
      },
      {
        path: "/shenpi2",
        name: "QiyeBang",
        component: QiyeBang,
        meta: { title: "企业帮填页" }
      },
      {
        path: "/GeRen",
        name: "GeRen",
        component: GeRen,
        meta: { title: "超管个人中心" }
      },
      {
        path: "/ShuJu",
        name: "ShuJu",
        component: ShuJu,
        meta: { title: "当日数据" }
      },
      {
        path: "/ShuJuOld",
        name: "ShuJuOld",
        component: ShuJuOld,
        meta: { title: "往日数据" }
      },
      {
        path: "/TongXunLu",
        name: "TongXunLu",
        component: TongXunLu,
        meta: { title: "通讯录" }
      }
    ]
  }
];

//移动端路由规则
const mobileRoutes = [
  {
    path:'/',
    redirect: '/bangtian', // 重定向到访客预约页面
    component:MobileHelloWorld,
    children:[
      {
        path: "/bangtian",
        name: "bangtian",
        component: IndexInfo,
        meta:{title:"访客预约"}
      },
      {
        path: "/shenpi", // 新添加的路径
        name: "Shenpi", // 新添加的名称
        component: DaofangShenpi, // 新添加的组件
        meta: { title: "到访审批" } // 新添加的标题
      },
      {
        path: "/shenpi2", // 新添加的路径
        name: "Shenpi2", // 新添加的名称
        component: DaofangShenpi2, // 新添加的组件
        meta: { title: "二级审批" } // 新添加的标题
      },
      {
        path: "/yuyue", // 新添加的路径
        name: "YuYue", // 新添加的名称
        component: YuyueRecord, // 新添加的组件
        meta: { title: "预约记录" } // 新添加的标题
      }
    ]
    
  },
  {
    path: "/visitor-form", // 新添加的路径
    name: "VisitorForm", // 新添加的名称
    component: VisitorForm, // 新添加的组件
    meta: { title: "访客信息填写" } // 新添加的标题
  }
]
// 判断设备类型
function isMobile() {
  return window.innerWidth < 768;
}

// 根据设备类型动态选择路由
const routes = isMobile() ? mobileRoutes : pcRoutes;

const router = new Router({
  mode: 'hash',
  routes
});


export default router;